import React from 'react';

import { UserProvider } from './UserContext';
import { AlertProvider } from './AlertContext';

const AppProvider = ({ children, userPermissions, alertFunctions }) => {
    return (
        <AlertProvider value={alertFunctions}>
            <UserProvider initialPermissions={userPermissions}>
                {children}
            </UserProvider>
        </AlertProvider>
    );
};

export default AppProvider;